import React, { useEffect, useState } from 'react';
import { Button, Alert, Box } from '@mui/material';
import { useParams, useNavigate } from "react-router-dom";
import { useGameUtils } from './utilities/GameUtils';
import { useAuth } from './contexts/AuthContext';
import { useInvitationUtils } from './utilities/InvitationUtils';

const SharedInvitation = () => {
  const [game, setGame] = useState();
  const { shareCode } = useParams();
  const { fetchGameByShareCode } = useGameUtils();
  const [fetchError, setFetchError] = useState(null);

  const { findInvitationForGameAndUser } = useInvitationUtils();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const game = await fetchGameByShareCode(shareCode);
        console.log(game);
        setGame(game);
        navigate(`/games/${game.id}`);
      } catch (error) {
        console.error('Error fetching game:', error);
        setFetchError('Failed to load game details. Please try again later.');
      } finally {
      }
    };
    
    fetchData();
  }, [shareCode, fetchGameByShareCode, navigate]);

  useEffect(() => {
    if (currentUser && game) {
      const loadInvitation = async () => {
        await findInvitationForGameAndUser(game, currentUser);
      }
      
      loadInvitation();
    }
  }, [currentUser, game, findInvitationForGameAndUser]);




  // if (isFetching) {
  //   return (
  //     <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  if (fetchError) {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        {fetchError}
      </Alert>
    );
  }

  if (!game) {
    return (
      <Alert severity="info" sx={{ mt: 2 }}>
        Game not found or has been removed.
      </Alert>
    );
  }

  if (currentUser && game) {
    const invitation = game.invitations.find((invitation) => invitation.userId === currentUser.uid);
    if (invitation && invitation.responded) {
      return (
        <Alert severity="info" sx={{ mt: 2 }}>
          You have already accepted this invitation.
          <Button onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
        </Alert>
      )
    }
  }

  return (
    <Box></Box>
  );
};

export default SharedInvitation;
